import React, { Component } from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link, matchPath, withRouter } from 'react-router-dom';
import { toPairs, path } from 'ramda';

import { routes } from '../../../routes';
import { debounce, toCurrency } from '../../../util/helpers';
import magic from '../../../util/magic';

import { apiGetMyEvents, apiGetUpcomingEvents } from '../../../api/event';
import Card from '../../../components/Card';

const propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
};

class List extends Component {
  state = {
    data: [],
    loading: true,
    pages: null,
    path: null,
    upcoming: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const newPath = path(['location', 'pathname'], nextProps);

    if (newPath != prevState.path) {
      return { path: newPath, upcoming: matchPath(newPath, { path: routes.events.upcoming }) };
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.upcoming !== prevState.upcoming) {
      this.getEvents({
        page: 0,
        pageSize: prevState.pageSize,
        sorted: prevState.sorted,
        filtered: prevState.filtered,
      });
    }
  }

  columns = [
    { id: 'products.name', Header: 'Name', accessor: 'name' },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: ({ value }) => magic.events[value],
      Filter: ({ filter, onChange }) => (
        <select
          className="form-control"
          onChange={(event) => onChange(event.target.value)}
          value={filter ? filter.value : ''}
        >
          <option value="" />
          {toPairs(magic.events).map((event) => (
            <option key={event[0]} value={event[0]}>
              {event[1]}
            </option>
          ))}
        </select>
      ),
    },
    {
      id: 'products.price',
      Header: 'Price',
      accessor: 'price',
      Cell: ({ value }) => toCurrency(value),
      Filter: <noscript />,
    },
    {
      id: 'free_for_members',
      Header: 'Free For Members',
      accessor: 'freeForMembers',
      Cell: ({ value }) => (value ? 'Yes' : 'No'),
      Filter: <noscript />,
    },
    {
      id: 'date',
      Header: 'Date',
      accessor: 'date',
      Cell: (date) => moment(date.value).format('MM/DD/YYYY'),
      Filter: <noscript />,
    },
  ];

  getEvents = ({ pageSize, page, sorted, filtered }) => {
    const searchFunction = this.state.upcoming ? apiGetUpcomingEvents : apiGetMyEvents;
    this.setState({ loading: true, pageSize, sorted, filtered });

    searchFunction({ pageSize, page: page + 1, sorted, filtered }).then((resp) => {
      const responseData = resp.data;
      this.setState({ loading: false, data: responseData.data, pages: responseData.lastPage });
    });
  };

  render() {
    const { data, loading, pages, upcoming } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col">
            <Card>
              <Card.Header compact>
                {upcoming ? 'Upcoming' : 'My'} Events
                <Link
                  className="btn btn-primary float-right"
                  to={upcoming ? routes.events.root : routes.events.upcoming}
                >
                  {upcoming ? 'View My Events' : 'View All Events'}
                </Link>
              </Card.Header>
              <Card.Body>Choose a event below to view more details</Card.Body>
            </Card>
          </div>
        </div>
        <ReactTable
          className="mt-4 -striped -highlight clickable card"
          data={data}
          columns={this.columns}
          pages={pages}
          loading={loading}
          manual
          onFetchData={debounce(this.getEvents, 300)}
          filterable
          defaultPageSize={10}
          getTrProps={(state, rowInfo) => {
            return {
              onClick: (e, handleOriginal) => {
                this.props.history.push(routes.events.viewBuilder(rowInfo.original.categoryId));

                if (handleOriginal) {
                  handleOriginal();
                }
              },
            };
          }}
          FilterComponent={({ filter, onChange }) => (
            <input
              type="text"
              className="form-control"
              placeholder="Filter..."
              value={filter ? filter.value : ''}
              onChange={(event) => onChange(event.target.value)}
            />
          )}
          defaultSorted={[
            {
              id: 'date',
              desc: true,
            },
          ]}
        />
      </div>
    );
  }
}

List.propTypes = propTypes;

export default withRouter(List);
